import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import MoreProducts from '../views/MoreProducts.vue'
import PolicyList from '../views/PolicyList.vue'
import PolicyImage from '../views/PolicyImage.vue'
import ShopDetail from '../views/ShopDetail.vue'
import CategoryShops from '../views/CategoryShops.vue'
import ProductDetail from '../views/ProductDetail.vue'
import SearchPage from '../views/SearchPage.vue'
import TownShops from '../views/TownShops.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/more-products',
    name: 'MoreProducts',
    component: MoreProducts
  },
  {
    path: '/policy-list',
    name: 'PolicyList',
    component: PolicyList
  },
  {
    path: '/policy-image',
    name: 'PolicyImage',
    component: PolicyImage
  },
  {
    path: '/shop/:id',
    name: 'ShopDetail',
    component: ShopDetail
  },
  {
    path: '/category/:categoryId',
    name: 'CategoryShops',
    component: CategoryShops
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail
  },
  {
    path: '/search',
    name: 'SearchPage',
    component: SearchPage
  },
  {
    path: '/search/:keyword',
    name: 'SearchPageKeyword',
    component: SearchPage
  },
  {
    path: '/town/:townId',
    name: 'TownShops',
    component: TownShops
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0 }
  }
})

export default router
